import { IconName } from "components/SvgInline/types";
import { CardScheme } from "library/api/payments";

interface CardDetails {
  displayName: string;
  iconName: IconName;
}

export const cardDetailsMap: Partial<Record<CardScheme, CardDetails>> = {
  VISA: {
    displayName: "Visa",
    iconName: "visa",
  },
  MASTERCARD: {
    displayName: "Mastercard",
    iconName: "master-card",
  },
};
